import React, { useEffect, useState } from 'react';
import {
  AbaDadosGerais,
  getDadosGerais,
  getDemanda,
  optionsTipo,
  updateTags,
  substituirAnexo,
  excluirAnexo,
  assumirDemanda,
  baixarTudoDadosGerais,
  devolverDemanda,
  cancelarDemanda,
  aprovarDemanda,
  downloadAnexoDemanda,
  viewAnexoDemanda,
  updateComprador,
  Demanda,
  updateCaracteristicaContratacao,
  updateAnexoAprovacao,
  downloadAnexoAnaliseRiscoPrivacidade,
  updateAnexoAnaliseRiscoPrivacidadeResultado,
  caracteristicaContratacaoOptions,
} from '@app/api/demanda';
import { baixarTemplateRiskAssessment } from '@app/api/template';
import { getTipoServicoOptions } from '@app/api/tipoServico';
import { getAllUsuariosSuprimentosptions } from '@app/api/usuario';
import CurrencyInput from '@app/components/CurrencyInput';
import { GetFileExtension, getLoggedId, imageFormats } from '@app/helpers';
import { hasPermission } from '@app/helpers/permissions';
import {
  Button,
  Col,
  FormDatePicker,
  FormInput,
  FormSelect,
  FormSwitch,
  FormTextArea,
  MasterDetailForm,
  Row,
  Table,
  usePromise,
  useRouter,
  Widget,
} from '@digital/ui';
import { Collapse, Icon, Tooltip } from 'antd';

import ModalIncluirAnexo from './ModalIncluirAnexo';
import ModalSubstituirAnexo from './ModalSubstituirAnexo';
import ModalDevolverDemanda from './ModalDevolverDemanda';
import ModalComentariosAnexoDemanda from '../QuestionarioContratacao/ModalComentariosAnexoDemanda';
import './custom.css';
import { UploadComponent } from '@app/components';
import { GetPreSuprimentos } from '@app/api/configuracoes';
import AbaDadosGeraisFaturamentoDireto from './AbaDadosGeraisFaturamentoDireto';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';

const AbaDadosGerais = () => {
  const { match } = useRouter();
  const { Panel } = Collapse;
  const [id, setId] = useState(match.path.split('/')[3]);
  const [childrenTags, setChildrenTags] = useState([]);
  const [update, setUpdate] = useState(false);
  const [selectedItem, setSelectedItem] = useState<Demanda>();
  const [configAnaliseRiscoPrivacidade, setConfigAnaliseRiscoPrivacidade] = useState<boolean>(false);

  useEffect(() => {
    getDemanda(id).then(data => setSelectedItem(data));
  }, [id]);

  useEffect(() => {
    GetPreSuprimentos().then(resp => {
      if (resp) {
        setConfigAnaliseRiscoPrivacidade(resp.preSuprimentosAnaliseRiscoPrivacidade);
      }
    });
  }, []);

  const [dadosGerais] = usePromise(
    () => {
      return selectedItem ? getDadosGerais(selectedItem.id) : Promise.resolve(undefined);
    },
    [selectedItem, update],
    {} as AbaDadosGerais,
  );

  const handleUpdateTags = (tags: string[]) => {
    if (selectedItem) {
      updateTags({ id: selectedItem.id, tags }).then(data => { });
    }
  };

  const handleExcluir = id => {
    excluirAnexo(id).then(data => {
      if (data.valid) {
        onUpdate();
      }
    });
  };

  const handleAssumir = () => {
    if (selectedItem) {
      assumirDemanda(selectedItem.id).then(data => {
        if (data.valid) {
          onUpdate();
        }
      });
    }
  };

  const handleDevolver = () => {
    if (selectedItem) {
      devolverDemanda(selectedItem.id).then(data => {
        if (data.valid) {
          onUpdate();
        }
      });
    }
  };

  const handleCancelar = () => {
    if (selectedItem) {
      cancelarDemanda(selectedItem.id).then(data => {
        if (data.valid) {
          onUpdate();
        }
      });
    }
  };

  const handleAprovar = () => {
    if (selectedItem) {
      aprovarDemanda(selectedItem.id).then(data => {
        if (data.valid) {
          onUpdate();
        }
      });
    }
  };

  const handleDownloadTudo = () => {
    if (selectedItem) {
      baixarTudoDadosGerais(selectedItem.id);
    }
  };

  const handleUpdateComprador = value => {
    if (selectedItem) {
      updateComprador({ id: selectedItem.id, compradorId: value }).then(data => {
        onUpdate();
      });
    }
  };

  const handleUpdateAnexoAprovacao = values => {
    updateAnexoAprovacao(values).then(data => {
      onUpdate();
    });
  };

  const handleUpdateAnexoAnaliseRiscoPrivacidadeResultado = values => {
    updateAnexoAnaliseRiscoPrivacidadeResultado(values).then(data => {
      onUpdate();
    });
  };

  const handleUpdateCaracteristicaContratacao = caracteristica => {
    if (selectedItem) {
      updateCaracteristicaContratacao({ id: selectedItem.id, caracteristica }).then(data => {
        onUpdate();
      });
    }
  };

  const onUpdate = () => {
    setUpdate(!update);
  };

  const columnsAnexo = [
    {
      title: 'Descrição',
      dataIndex: 'descricaoDocumento',
      width: '45%',
    },
    {
      title: 'Arquivo',
      dataIndex: 'arquivoAtual.nome',
      width: '20%',
    },
    {
      title: 'Ações',
      width: '10%',
      className: 'td-centralizado',
      render: (index, record) => (
        <>
          {hasPermission(['PRE_SUPRIMENTOS_DEMANDA_SUBSTITUIR_ANEXO']) && dadosGerais.statusDemandaCodigo == 2 ? (
            <>
              {record.arquivoAtual.local ? (
                <ModalSubstituirAnexo record={record} onUpdate={onUpdate} />
              ) : (
                <Tooltip title="Anexar">
                  <UploadComponent
                    id={record.arquivos[0].id}
                    nomeIdFormulario={'Id'}
                    enderecoApi={'anexoDemanda/UploadSuprimentos'}
                    idDoComponente={record.arquivos[0].id}
                    iconName="messaging-attach"
                    retorno={async data => {
                      if (data.valid) {
                        onUpdate();
                      }
                    }}
                    hasFile={record.arquivoAtual && record.arquivoAtual.local}
                  />
                </Tooltip>
              )}
            </>
          ) : (
            <></>
          )}

          {record.obrigatorio === false &&
            hasPermission(['PRE_SUPRIMENTOS_DEMANDA_SUBSTITUIR_ANEXO']) &&
            dadosGerais.statusDemandaCodigo == 2 ? (
            <Tooltip title="Excluir">
              <Button
                icon="science-minus"
                type="link"
                title=""
                onClick={() => {
                  handleExcluir(record.id);
                }}
              />
            </Tooltip>
          ) : (
            <></>
          )}

          {record.arquivoAtual && record.arquivoAtual.local && (
            <>
              <Tooltip title="Download Arquivo">
                <Button
                  icon="ui-download"
                  type="link"
                  onClick={() => {
                    downloadAnexoDemanda(record.arquivoAtual.id, record.arquivoAtual.nome);
                  }}
                />
              </Tooltip>
              {GetFileExtension(record.arquivoAtual.nome) === 'pdf' ||
                imageFormats.includes(GetFileExtension(record.arquivoAtual.nome)) ? (
                <Tooltip title="Visualizar Arquivo">
                  <Button
                    icon="files-view_file"
                    type="link"
                    onClick={() => {
                      viewAnexoDemanda(record.arquivoAtual.id, record.arquivoAtual.nome);
                    }}
                  />
                </Tooltip>
              ) : (
                <></>
              )}
            </>
          )}
        </>
      ),
    },
    {
      title: 'Comentários',
      width: '10%',
      dataIndex: 'contemComentarios',
      className: 'td-centralizado',
      render: (index, record) => {
        return (
          <Tooltip title="Comentários">
            <ModalComentariosAnexoDemanda
              preSuprimentos={true}
              anexoId={record.id}
              contemComentario={record.contemComentarios}
            />
          </Tooltip>
        );
      },
    },
    {
      title: 'Status',
      width: '15%',
      render: (text, record) => (
        <FormSelect
          name="aprovado"
          value={record.aprovado === undefined ? record.aprovado : record.aprovado ? 1 : 0}
          onChange={e => handleUpdateAnexoAprovacao({ id: record.id, aprovado: e })}
          options={[
            { text: 'Validado', value: 1 },
            { text: 'Devolvido', value: 0 },
          ]}
          disabled={dadosGerais.statusDemandaCodigo != 2 && !hasPermission(['PRE_SUPRIMENTOS_DEMANDA_APROVAR_ANEXO'])}
        />
      ),
    },
  ];

  const columnsAnexoAnaliseRiscoPrivacidade = [
    {
      title: 'Descrição',
      dataIndex: 'descricaoDocumento',
      width: '45%',
    },
    {
      title: 'Arquivo',
      dataIndex: 'nome',
    },
    {
      title: 'Ações',
      width: '10%',
      className: 'td-centralizado',
      render: (index, record) => (
        <>
          {record && (
            <>
              {hasPermission(['PRE_SUPRIMENTOS_DEMANDA_SUBSTITUIR_ANEXO']) && dadosGerais.statusDemandaCodigo == 2 && (
                <Tooltip title="Adicionar Arquivo">
                  <UploadComponent
                    nomeIdFormulario={'id'}
                    key={record.id}
                    id={record.id}
                    retorno={() => onUpdate()}
                    iconName={'ui-upload'}
                    idDoComponente={record.id}
                    hasFile={false}
                    enderecoApi={'anexoDemanda/UploadAnexoAnaliseRiscoPrivacidade'}
                  />
                </Tooltip>
              )}
              <Tooltip title="Download Arquivo">
                <Button
                  icon="ui-download"
                  type="link"
                  onClick={() => {
                    downloadAnexoAnaliseRiscoPrivacidade(record.id, record.nome);
                  }}
                />
              </Tooltip>
              {record.temResultado && (
                <Tooltip title="Download Template">
                  <Button icon="business-new_resume_template" onClick={() => baixarTemplateRiskAssessment()} />
                </Tooltip>
              )}
            </>
          )}
        </>
      ),
    },
    {
      title: 'Resultado',
      dataIndex: 'resultado',
      width: '15%',
      render: (text, record) => (
        <>
          {record.temResultado && (
            <FormSelect
              name="resultado"
              value={record.resultado}
              onChange={e => handleUpdateAnexoAnaliseRiscoPrivacidadeResultado({ id: record.id, resultado: e })}
              options={[
                { text: 'Privacy Assessment', value: 'Privacy Assessment' },
                { text: 'Contratação Padrão', value: 'Contratação Padrão' },
              ]}
              disabled={
                dadosGerais.statusDemandaCodigo != 2 && !hasPermission(['PRE_SUPRIMENTOS_DEMANDA_APROVAR_ANEXO'])
              }
            />
          )}
        </>
      ),
    },
  ];

  const widgetActions = () => {
    const actions = [];

    if (dadosGerais.statusDemandaCodigo === 2) {
      if (hasPermission(['PRE_SUPRIMENTOS_DEMANDA_ASSUMIR'])) {
        if (dadosGerais.responsavelGpcId !== getLoggedId()) {
          actions.push(
            <Button type="link" onClick={handleAssumir}>
              Assumir
            </Button>,
          );
        }
      }
    }

    if (dadosGerais.statusDemandaCodigo === 5 || dadosGerais.statusDemandaCodigo === 2) {
      if (hasPermission(['PRE_SUPRIMENTOS_DEMANDA_DEVOLVER'])) {
        actions.push(<ModalDevolverDemanda onUpdate={onUpdate} />);
      }
    }

    if (dadosGerais.statusDemandaCodigo === 2) {
      if (hasPermission(['PRE_SUPRIMENTOS_DEMANDA_APROVAR'])) {
        actions.push(
          <Button type="success" onClick={handleAprovar}>
            Validar
          </Button>,
        );
      }
    }

    if (dadosGerais.statusDemandaCodigo === 5) {
      if (hasPermission(['PRE_SUPRIMENTOS_DEMANDA_CONCLUIR'])) {
        actions.push(
          <Button type="success" onClick={handleAprovar}>
            Concluir
          </Button>,
        );
      }
    }
    return actions;
  };

  return (
    <>
      {selectedItem && (selectedItem.tipo === ETipoDemanda.FaturamentoDireto || selectedItem.tipo === ETipoDemanda.AditivoFaturamentoDireto) &&
      <AbaDadosGeraisFaturamentoDireto/>
      } 
      {selectedItem && selectedItem.tipo !== ETipoDemanda.FaturamentoDireto && selectedItem.tipo !== ETipoDemanda.AditivoFaturamentoDireto ? (
        <Collapse bordered={false} defaultActiveKey={'dadosGerais'} expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel key="dadosGerais" header={<span>{selectedItem.identificadorTexto}</span>}>
            <Widget actions={widgetActions()}>
              <MasterDetailForm initialValues={dadosGerais}>
                <Row>
                  <FormInput label="Identificação" name="identificadorTexto" span={4} disabled />
                  <FormInput label="Status" name="statusDemandaTexto" span={4} disabled />
                  <FormInput label="Responsável Dep. Pré-Contratação" name="responsavelGpc" span={4} disabled />
                </Row>
                <Row>
                  <FormSelect options={optionsTipo} label="Tipo" name="tipo" span={4} disabled />
                  {dadosGerais.tipo === 1 && (
                    <CurrencyInput label="Expectativa de Valor Final" id='mrn-input-expectativaValorFinal' name="expectativaValorFinal" span={4} disabled />
                  )}
                  {dadosGerais.tipo === 2 && (
                    <CurrencyInput label="Valor do Aditivo" name="valorAditivo" span={4} disabled />
                  )}
                  <FormInput label="Demandante" name="demandante" span={4} disabled />
                </Row>

                {dadosGerais.tipo === 2 && (
                  <Row>
                    <FormInput span={4} name="numeroContrato" label="Número do Contrato/PCS" disabled />
                    <FormInput span={2} name="codFornecedor" label="Fornecedor" disabled />
                    <FormInput span={6} name="nomeFornecedor" label=" " disabled />
                  </Row>
                )}

                <Row>
                  <FormInput label="Diretoria" name="diretoriaTexto" span={4} disabled />
                  <FormInput label="Área" name="areaTexto" span={4} disabled />
                  <FormInput label="Departamento" name="departamentoTexto" span={4} disabled />
                </Row>

                {dadosGerais.tipo === 1 ? (
                  <>
                    <Row>
                      <FormTextArea
                        id="mrn-textarea-objetoASerContratado"
                        label="Objeto a ser contratado" name="objeto" rows={1} span={12} disabled />
                    </Row>
                    {(dadosGerais.statusDemandaCodigo === 5 ||
                      dadosGerais.statusDemandaCodigo === 7 ||
                      dadosGerais.statusDemandaCodigo === 8 ||
                      dadosGerais.statusDemandaCodigo === 10) && (
                        <Row>
                          <FormTextArea
                            id="mrn-textarea-justificativaRequisicaoCompra"
                            label="Justificativa da Contratação"
                            name="justificativa"
                            rows={1}
                            span={12}
                            disabled
                          />
                        </Row>
                      )}
                    <Row>
                      <FormSelect
                        id="mrn-select-tipoServico"
                        getOptions={getTipoServicoOptions}
                        label="Tipo de Serviço"
                        name="tipoServico.id"
                        span={4}
                        disabled
                      />
                      <FormSwitch label="Mão de Obra em PTR?" name="haveraMaoDeObraEmPTR" span={2} disabled />
                      <FormSwitch id="mrn-switch-haveraSla" label="Haverá SLA?" name="haveraSla" span={2} disabled />
                      <FormSwitch
                        label="Despesas Reembolsáveis?"
                        name="haveraDespesasReembolsaveis"
                        span={2}
                        disabled
                      />
                    </Row>
                  </>
                ) : (
                  <></>
                )}

                {dadosGerais.tipo == 1 &&
                  (dadosGerais.statusDemandaCodigo === 5 ||
                    dadosGerais.statusDemandaCodigo === 8 ||
                    dadosGerais.statusDemandaCodigo === 10) && (
                    <Row style={{ margin: '0px !important' }}>
                      <fieldset>
                        <legend>DDI - Due Diligence de Integridade</legend>
                        <Row style={{ paddingLeft: '10px' }}></Row>
                        <Row>
                          <FormInput label="Prazo em meses" name="expectativaDePrazo" span={2} disabled />
                          <CurrencyInput
                            label="Expectativa de Valor Final"
                            name="expectativaValorFinal"
                            id='mrn-input-expectativaValorFinal'
                            span={4}
                            disabled
                          />
                          <FormSelect
                            label="Característica de Contratação"
                            name="caracteristicaContratacao"
                            getOptions={caracteristicaContratacaoOptions}
                            span={4}
                            disabled
                          />
                          <FormSwitch label="Elegível DDI?" name="isDdi" span={2} disabled />
                        </Row>
                      </fieldset>
                    </Row>
                  )}

                {selectedItem.statusCodigo === 4 ||
                  selectedItem.statusCodigo === 5 ||
                  selectedItem.statusCodigo === 7 ||
                  selectedItem.statusCodigo === 8 ||
                  selectedItem.statusCodigo === 10 ? (
                  <Row style={{ margin: '0px !important' }}>
                    {dadosGerais.tipo == 1 ? (
                      <fieldset>
                        <legend>Suprimentos</legend>
                        <Row>
                          <FormInput label="Req. Compra" name="requisicaoCompra" span={3} disabled />
                          <FormInput label="Ordem de Compra" name="ordemCompra" span={3} disabled />
                          <FormSelect
                            getOptions={getAllUsuariosSuprimentosptions}
                            name="compradorId"
                            label="Nome do Comprador"
                            span={4}
                            onChange={e => handleUpdateComprador(e)}
                            disabled={
                              dadosGerais.statusDemandaCodigo != 5 ||
                              !hasPermission(['SAS_ALTERAR_COMPRADOR'])
                            }
                          />
                          <FormInput name="compradorERP" label="Identificador ERP Comprador" span={2} disabled />
                        </Row>
                        <Row>
                          {/* <FormInput label="Objeto desta OC no Totvs" name="objetoTotvs" span={12} disabled /> */}
                        </Row>
                        <Row>
                          {/* <FormInput
                            label="Justificativa desta OC no Totvs"
                            name="justificativaTotvs"
                            span={12}
                            disabled
                          /> */}
                        </Row>
                      </fieldset>
                    ) : (
                      <></>
                    )}

                    {dadosGerais.tipo === 2 ? (
                      <fieldset>
                        <legend>Suprimentos</legend>
                        {dadosGerais.isPrazo && (
                          <Row>
                            <FormDatePicker
                              format="DD/MM/YYYY"
                              label="Prazo Atual do Contrato"
                              name="prazoAtual"
                              span={4}
                              disabled
                            />
                            <FormDatePicker format="DD/MM/YYYY" label="Novo Prazo" name="novoPrazo" span={4} disabled />
                          </Row>
                        )}
                        {(dadosGerais.isValorComAcrescimoEscopo || dadosGerais.isValorSemAcrescimoEscopo) && (
                          <Row>
                            <CurrencyInput label="Valor Atual" name="valorAtual" span={4} disabled />
                            <CurrencyInput label="Valor Aditivo" name="valorAditivo" span={4} disabled />
                            <CurrencyInput label="Novo Valor Final" name="novoValorFinal" span={4} disabled />
                          </Row>
                        )}

                        {dadosGerais.isPrazo && (
                          <Row>
                            <FormTextArea
                              label="Resumo Alterações Cláusulas"
                              name="resumoAlteracoesClausula"
                              rows={1}
                              span={12}
                              disabled
                            />
                          </Row>
                        )}
                      </fieldset>
                    ) : (
                      <></>
                    )}
                  </Row>
                ) : (
                  <></>
                )}

                {selectedItem.statusCodigo !== 9 ? (
                  <>
                    <Row>
                      <ModalIncluirAnexo onUpdate={onUpdate} />
                      <Table columns={columnsAnexo} dataSource={dadosGerais.anexosDemanda} />
                    </Row>
                    {hasPermission(['PRE_SUPRIMENTOS_DEMANDA_BAIXAR_TODOS_ANEXOS']) && (
                      <Row>
                        <Button style={{ float: 'right' }} onClick={() => handleDownloadTudo()}>
                          Baixar Tudo
                        </Button>
                      </Row>
                    )}
                  </>
                ) : (
                  <></>
                )}

                {selectedItem.statusCodigo !== 9 ? (
                  <>
                    {configAnaliseRiscoPrivacidade && dadosGerais.tipo === 1 && (
                      <Row style={{ paddingTop: '20px', paddingBottom: '10px' }}>
                        <fieldset>
                          <legend>Análise de Risco de Privacidade</legend>
                          <Table
                            columns={columnsAnexoAnaliseRiscoPrivacidade}
                            dataSource={dadosGerais.anexoDemandaAnaliseRiscoPrivacidade}
                          />
                        </fieldset>
                      </Row>
                    )}
                  </>
                ) : (
                  <></>
                )}

                {selectedItem.statusCodigo !== 9 ? (
                  <>
                    {dadosGerais.tipo == 1 && (
                      <Row>
                        <FormSelect
                          label="Palavras Chaves"
                          onChange={v => handleUpdateTags(v)}
                          options={childrenTags}
                          mode="tags"
                          name="tags"
                        />
                      </Row>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </MasterDetailForm>
            </Widget>
          </Panel>
        </Collapse>
      ) : null}
    </>
  );
};

export default AbaDadosGerais;
